module.exports = __webpack_public_path__ + "static/media/masjid_ummu_kulthum_hilal8.526bdd25.webp";